<script lang="tsx" setup></script>

<template>
  <div class="text-[0.7em] absolute -translate-y-full">
    <slot />
  </div>
</template>
